import {
  Box,
  Button,
  Checkbox,
  FormGroup,
  Grid,
  Modal,
  TextField
} from '@mui/material'
import React, { useState } from 'react'
import {
  TextBold,
  TextRegular,
  TextSemiBold
} from '../../../commonComponents/TextStyling'
import { useTheme } from '@mui/material/styles'
import CloseIcon from '@mui/icons-material/Close'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import { useNavigate } from 'react-router-dom'
import {
  colorWithOpacity,
  isEmpty,
  isEmptyJson,
  showToast,
  validateEmail
} from '../../../utils/AppHelper'
import serverData from '../../../api/ServerData'
import { logoutUser } from '../../../actions/loginActions'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import AppButton from '../../../commonComponents/AppButton'
import ImageComponent from '../../../commonComponents/ImageComponent'
import appassets from '../../../utils/appassets'
import CompanyDetailsUI from '../../../commonComponents/CompanyDetailsUI'
import { ENV } from '../../../ENV'
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: '#FFFFFF',
  borderRadius: 2,
  boxShadow: 5,
  padding: '24px',
  width: '60%',
  height: '80vh',
  overflowY: 'auto'
}

const responsiveStyle = {
  position: 'absolute',
  transform: 'translate(-0%, -0%)',
  bgcolor: '#FFFFFF',
  padding: '24px',
  width: '100%',
  height: '100%',
  overflowY: 'auto'
}

export default function WorklistModal ({ data, matches }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  var theme = useTheme()
  const [added, setAdded] = useState(false)
  const [addedMsg, setAddedMsg] = useState('')
  var { open, button, item, onClose } = data

  //to-do  API calling
  const removeCandidateReasons = [
    {
      id: '1',
      label: `I want to work on the recently posted jobs on ${ENV.product_name}.`
    },
    { id: '2', label: 'I am occupied with different opportunities.' },
    {
      id: '3',
      label: 'I am unable to find candidates who are suitable for this job.'
    },
    { id: '4', label: 'This job is outside of my recruiting background.' },
    {
      id: '5',
      label: `I am forced to opt out because ${ENV.product_name} allows me to work on limited jobs.`
    },
    { id: '6', label: 'I made submissions.' }
  ]

  const [isExist, setIsExist] = useState('')

  const [email, setEmail] = useState('')
  const [submit, setSubmit] = useState('')
  const [formError, setFormError] = useState({})
  const [removeFormError, setRemoveFormError] = useState({})

  const [removeCandidateRes, setRemoveCandidateRes] = useState([])
  const [showOtherText, setShowOtherText] = useState(false)
  const [otherText, setOtherText] = useState('')
  const [loading, setLoading] = useState(false)

  const handleAddWorklist = () => {
    const error = {}
    if (isEmpty(submit)) {
      error.submit = 'Please select one of the options below'
    } else {
      setLoading(true)

      serverData.worklist(
        { jobId: item?.jobId, comment: submit },
        result => {
          if (result.status) {
            setAdded(true)
            setAddedMsg(result.message)
          } else {
            showToast(result.message)
          }
          setLoading(false)
        },
        error => {
          if (error.status === 401) {
            setLoading(false)
            dispatch(logoutUser(navigate)) // eslint-disable-next-line
          }
        }
      )
    }
    setFormError(error)
  }

  const removeValidation = () => {
    const error = {}

    if (showOtherText) {
      if (isEmpty(otherText)) {
        error.otherText =
          'Please write the reason to remove this job from worklist.'
      }
    } else {
      if (isEmptyJson(removeCandidateRes)) {
        error.removeCandidateRes = 'Please select one of the options below'
      }
    }
    setRemoveFormError(error)
    return Object.keys(error).length === 0
  }

  const removeFromWorklistApi = () => {
    setLoading(true)

    if (removeValidation()) {
      serverData.removeFromWorklist(
        {
          id: item.id,
          jobId: item?.jobId,
          reasons: removeCandidateRes,
          otherReason: otherText
        },
        result => {
          if (result.status) {
            showToast(result.message, false)
            onClose(true)
            setLoading(false)
          } else {
            setLoading(false)
            showToast(result.message)
          }
        },
        error => {
          if (error.status === 401) {
            dispatch(logoutUser(navigate)) // eslint-disable-next-line
            setLoading(false)
          }
        }
      )
      setLoading(false)
    } else {
      setLoading(false)
    }
  }

  const handleOkGotIt = () => {
    onClose()
    setAdded(false)
    navigate('/recruiter/worklist')
  }

  const handleRemoveCandiate = event => {
    const value = event.target.value
    setRemoveCandidateRes(prev => {
      const newArray = [...prev]
      const index = newArray.findIndex(item => item === value)
      if (index === -1) {
        newArray.push(value)
      } else {
        newArray.splice(index, 1)
      }
      return newArray
    })
  }

  return (
    <Modal open={open} onClose={() => onClose()}>
      <Box sx={matches ? responsiveStyle : style}>
        <CloseIcon
          onClick={() => onClose()}
          style={{
            position: 'absolute',
            right: matches ? 16 : 4,
            top: matches ? 16 : 4,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            borderRadius: 20,
            fontSize: '24px',
            cursor: 'pointer'
          }}
        />
        <Grid
          container
          spacing={2}
          style={{ padding: '12px 0px 0px 12px', marginTop: matches && '12px' }}
        >
          <Grid item xs={12} style={{ padding: '0px' }}>
            <Grid container spacing={0} style={{ padding: '0px' }}>
              <Grid item xs={12} style={{ padding: '0px' }}>
                {button === 'addWorklist' && (
                  <TextSemiBold style={{ fontSize: '16px' }}>
                    How committed are you to filling this job?
                  </TextSemiBold>
                )}
                {button === 'removeCandidate' && (
                  <TextRegular style={{ fontSize: '18px' }}>
                    Why are you removing this job from your worklist?
                  </TextRegular>
                )}
              </Grid>

              <Grid
                item
                xs={12}
                style={{
                  border: `1px solid ${theme.palette.border.main}`,
                  marginTop: '16px',
                  display: 'flex',
                  padding: '32px 16px'
                }}
              >
                <CompanyDetailsUI item={item} />
              </Grid>

              {button === 'avoideDuplicate' && (
                <>
                  <Grid item xs={12} sx={{ mt: '24px' }}>
                    <TextRegular
                      style={{
                        color: theme.palette.text.secondary,
                        fontSize: '16px'
                      }}
                    >
                      Please enter the email id of your candidate to check if
                      the candidate is already submitted to the{' '}
                      {item?.companyname}.
                    </TextRegular>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: 'flex',
                      justifyContent: 'left',
                      margin: '24px 0px'
                    }}
                  >
                    <TextField
                      value={email}
                      onChange={e => {
                        setIsExist('')
                        var { value } = e.target
                        if (value.length < 60) {
                          setEmail(value)
                        }
                      }}
                      placeholder='Email address of candidate'
                    />

                    <Button
                      onClick={() => {
                        if (isEmpty(email)) {
                          showToast('Please enter candidate email address')
                        } else if (!validateEmail(email)) {
                          showToast('Please enter valid email address')
                        } else {
                          serverData.checkCandiate(
                            { jobId: item?.jobId, email: email },
                            data => {
                              if (data.response.isExist) {
                                setIsExist('exist')
                              } else {
                                setIsExist('notExist')
                              }
                            },
                            error => {
                              showToast(error.statusText)
                            }
                          )
                        }
                      }}
                      variant='contained'
                      style={{ textTransform: 'none', marginLeft: '16px' }}
                    >
                      Check
                    </Button>
                  </Grid>

                  {isExist === 'exist' && (
                    <>
                      <Grid
                        item
                        xs={12}
                        style={{
                          border: `1px solid ${theme.palette.text.error}`,
                          margin: '16px',
                          display: 'flex',
                          padding: '16px',
                          borderRadius: '4px',
                          backgroundColor: colorWithOpacity(
                            theme.palette.text.error,
                            0.2
                          )
                        }}
                      >
                        <Grid container spacing={0}>
                          <Grid item xs={12}>
                            <TextRegular
                              style={{ color: `${theme.palette.text.error}` }}
                            >
                              The email id: {email} has already been submitted
                            </TextRegular>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  )}
                  {isExist === 'notExist' && (
                    <>
                      <Grid
                        item
                        xs={12}
                        style={{
                          border: `1px solid ${theme.palette.text.success}`,
                          margin: '16px',
                          display: 'flex',
                          padding: '16px',
                          borderRadius: '4px',
                          backgroundColor: colorWithOpacity(
                            theme.palette.text.success,
                            0.2
                          )
                        }}
                      >
                        <Grid container spacing={0}>
                          <Grid item xs={12}>
                            <TextRegular
                              style={{ color: `${theme.palette.text.success}` }}
                            >
                              The candidate with the email id: {email} is not
                              yet submitted to {item.companyname}. Please
                              proceed with submitting the application.
                            </TextRegular>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </>
              )}
              {added === true ? (
                <Grid
                  item
                  xs={12}
                  style={{
                    border: `1px solid ${theme.palette.text.success}`,
                    marginTop: '32px',
                    display: 'flex',
                    padding: '16px',
                    borderRadius: '4px',
                    backgroundColor: colorWithOpacity(
                      theme.palette.text.success,
                      0.2
                    )
                  }}
                >
                  <Grid container spacing={0}>
                    <Grid item xs={12}>
                      <TextSemiBold
                        style={{ color: `${theme.palette.text.success}` }}
                      >
                        You've added this job to your worklist!
                      </TextSemiBold>
                    </Grid>
                    <Grid item xs={12}>
                      <TextRegular
                        style={{
                          color: `${theme.palette.text.success}`,
                          whiteSpace: 'pre-line'
                        }}
                      >
                        {addedMsg}
                      </TextRegular>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <>
                  {button === 'addWorklist' && (
                    <Grid item xs={12} style={{ padding: '0px' }}>
                      <FormControl style={{ marginTop: '32px', flexGrow: 1 }}>
                        <FormHelperText
                          sx={{ color: theme.palette.text.error }}
                        >
                          {formError.submit}
                        </FormHelperText>
                        <RadioGroup
                          aria-labelledby='demo-radio-buttons-group-label'
                          name='radio-buttons-group'
                          value={submit}
                          onChange={event => setSubmit(event.target.value)}
                        >
                          <FormControlLabel
                            control={<Radio />}
                            label='I will give it a try'
                            value='I will give it a try'
                          />
                          <FormControlLabel
                            value='I am committed to submitting qualified candidates'
                            control={<Radio />}
                            label='I am committed to submitting qualified candidates'
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  )}
                  {button === 'removeCandidate' && (
                    <>
                      <Grid item xs={12} style={{ paddingTop: '16px' }}>
                        <FormHelperText
                          sx={{ color: theme.palette.text.error }}
                        >
                          {removeFormError.removeCandidateRes}
                        </FormHelperText>
                        <FormGroup>
                          {removeCandidateReasons.map(item => (
                            <FormControlLabel
                              key={item?.id}
                              control={
                                <Checkbox
                                  value={item?.id}
                                  onChange={handleRemoveCandiate}
                                  checked={removeCandidateRes.includes(
                                    item?.id
                                  )}
                                />
                              }
                              label={item?.label}
                              style={{ color: theme.palette.text.secondary }}
                            />
                          ))}

                          <FormControlLabel
                            key={'otherReason'}
                            control={
                              <Checkbox
                                value={'otherReason'}
                                onChange={() =>
                                  setShowOtherText(!showOtherText)
                                }
                              />
                            }
                            label={'Other Reasons'}
                            style={{ color: theme.palette.text.secondary }}
                          />
                        </FormGroup>
                      </Grid>
                      <Grid item xs={12}>
                        {showOtherText === true && (
                          <FormControl
                            fullWidth
                            margin='normal'
                            error={removeFormError.otherText}
                          >
                            <TextField
                              required
                              placeholder='Please type you comments here to let us know the reaso for removing this job from you worklist.'
                              fullWidth
                              value={otherText}
                              onChange={e => {
                                var { value } = e.target
                                if (value.length < 200) {
                                  setOtherText(value)
                                }
                              }}
                              error={removeFormError.otherText}
                              helperText={removeFormError.otherText}
                              sx={{
                                input: { color: theme.palette.text.secondary }
                              }}
                            />
                          </FormControl>
                        )}
                      </Grid>
                    </>
                  )}
                </>
              )}
            </Grid>
            {added === true ? (
              <>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0px',
                    marginTop: '32px'
                  }}
                >
                  <Button
                    variant='outlined'
                    style={{ textTransform: 'none' }}
                    onClick={handleOkGotIt}
                  >
                    Ok, got it.
                  </Button>
                </Grid>
              </>
            ) : (
              <>
                {button === 'addWorklist' && (
                  <Grid
                    item
                    xs={12}
                    style={{
                      marginTop: '32px',
                      display: 'flex'
                    }}
                  >
                    <Grid
                      item
                      style={{
                        padding: '0px',
                        marginRight: '16px'
                      }}
                    >
                      <AppButton
                        variant='contained'
                        style={{ textTransform: 'none' }}
                        name='Add to worklist'
                        disabled={false}
                        loading={loading}
                        onClick={() => handleAddWorklist()}
                      />
                    </Grid>
                    <Grid
                      item
                      style={{
                        padding: '0px'
                      }}
                    >
                      <Button
                        variant='outlined'
                        style={{ textTransform: 'none' }}
                        onClick={() => onClose()}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                )}
                {button === 'removeCandidate' && (
                  <>
                    <Grid item>
                      <AppButton
                        variant='outlined'
                        style={{
                          textTransform: 'none',
                          width: 'fit-content',
                          marginTop: '10px'
                        }}
                        name='Remove from Worklist'
                        loading={loading}
                        onClick={removeFromWorklistApi}
                      />
                    </Grid>
                  </>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </Box>
    </Modal>
  )
}
